<template>
    <section class="nav-sidebar">
        <b-sidebar
            position="fixed"
            fullheight
            overlay
            :open="open"
            v-on:close="closeNav"
            right
        >
            <div class="menu-list-wrapper">
                <b-menu>
                    <b-menu-list label="Navigation" class="nav-sidebar-list"> 
                        <b-menu-item :active="activeRoute === '/'" @click="closeNav()" label="Home" tag="router-link" to="/"></b-menu-item>
                        <b-menu-item :active="activeRoute === '/docs'" @click="closeNav()" label="Docs" tag="router-link" to="/docs"></b-menu-item>
                        <b-menu-item :active="activeRoute === '/shop'" @click="closeNav()" label="Shop" tag="router-link" to="/shop"></b-menu-item>
                        <b-menu-item :active="activeRoute === '/blog'" @click="closeNav()" label="Blog" tag="router-link" to="/blog"></b-menu-item>
                        <b-menu-item :active="activeRoute === '/premium'" @click="closeNav()" label="Premium" tag="router-link" to="/premium" class="premium-link"></b-menu-item>
                    </b-menu-list>
                    <b-menu-list label="User" v-if="!$store.getters.getToken">
                        <b-menu-item  icon="discord" icon-pack="fab" class="login-button" @click="closeNav()" label="Login with Discord" tag="router-link" to="/login"></b-menu-item>
                    </b-menu-list>
                    <!-- Mirrors the desktop account menu: your profile, then
                         the settings behind it, then the way out.

                         Profile was missing entirely here, so on a phone the
                         only route to your own profile was a link from
                         somewhere else. Settings matters just as much now that
                         managing a subscription lives on the Customize tab —
                         without it a phone had no route to Stripe at all
                         except the status card on /premium. -->
                    <b-menu-list label="User" v-else>
                        <b-menu-item
                            icon="user"
                            icon-pack="fas"
                            :active="activeRoute.startsWith('/profile')"
                            @click="closeNav()"
                            tag="router-link"
                            to="/profile/me">
                            <!-- A slot rather than `label`, so the count can
                                 sit beside the word. The burger that opened
                                 this menu carries the same badge; this is
                                 what says which entry it was about. -->
                            <template #label>
                                Profile
                                <span
                                    v-if="unclaimedCount"
                                    class="sidebar-unclaimed"
                                    :aria-label="`${unclaimedCount} ${unclaimedCount === 1 ? 'reward' : 'rewards'} to claim`"
                                >{{ unclaimedCount > 9 ? '9+' : unclaimedCount }}</span>
                            </template>
                        </b-menu-item>
                        <b-menu-item
                            icon="cog"
                            icon-pack="fas"
                            @click="closeNav()"
                            label="Settings"
                            tag="router-link"
                            to="/profile/me/customize"></b-menu-item>
                        <b-menu-item  icon="sign-out-alt" icon-pack="fas"  class="logout-button" @click="$store.dispatch('logout')" label="Logout"></b-menu-item>
                    </b-menu-list>
                </b-menu>
            </div>
        </b-sidebar>
    </section>
</template>

<script>
export default {
  name: 'NavSidebar',
  computed: {
    /**
     * Same source as the nav bar's badge — `dbInfo`, loaded on every page —
     * so the two can't disagree about how many rewards are waiting.
     */
    unclaimedCount() {
        const count = this.$store.state.dbInfo.unclaimedCount
        return typeof count === 'number' && count > 0 ? count : 0
    },
  },
  props: {
    open: Boolean,
    // Defaulted because the template calls .startsWith() on it — an absent
    // prop would throw during render rather than merely fail to highlight.
    activeRoute: { type: String, default: '' }
  },
  methods: {
      closeNav() {
          this.$emit('close')
      }
  }
}
</script>

<style lang="scss">
.b-sidebar .sidebar-content.is-right {
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    .menu-list-wrapper {
        padding: 1rem;
        .menu-list .login-button a {
            background-color: $discord;
            color: #fff;
            &:hover {
                background-color: $discord;
            }
        }
        .menu-list .sidebar-unclaimed {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 1.25rem;
            height: 1.25rem;
            margin-left: 0.4rem;
            padding: 0 0.3rem;
            border-radius: 999px;
            background-color: $danger;
            color: #fff;
            font-size: 0.7rem;
            font-weight: 700;
            line-height: 1;
            font-variant-numeric: tabular-nums;
        }
        .menu-list .logout-button a {
            background-color: $danger;
            color: #fff;
            &:hover {
                background-color: $danger-dark;
            }
        }
    }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
